class FaqCategories extends HTMLElement {
  constructor() {
    super();

    this.loader = this.querySelector('[data-loader]');
    this.questions = this.querySelectorAll('[data-faq-item]');
    this.categoryButtons = this.querySelectorAll('[data-faq-category]');
    this.dropdown = this.querySelector('[data-faq-dropdown]');

    // Search
    this.noResultsText = this.querySelector('[data-faq-no-results-text]');
    this.form = this.querySelector('form');
    this.json = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    // Add the event listeners
    this.categoryButtons.forEach(button => button.addEventListener('click', this.toggleCategory.bind(this)));
    this.dropdown.addEventListener('change', this.toggleCategory.bind(this));
    this.form.addEventListener('submit', this.search.bind(this));

    // Load the first category on load
    window.addEventListener('DOMContentLoaded', () => {
      this.loader.classList.add('hidden');
      this.toggleCategory(this.categoryButtons[0]);
    });
  }

  toggleCategory(event) {
    this.showNoResultsText(false);

    const element = event.target || event;
    const category = element.dataset.faqCategory || element.value;
    this.questions.forEach(question => question.classList.toggle('hidden', question.dataset.collapsibleGroup !== category));
    this.questions.forEach(question => question.classList.remove('cc-is-open'));

    // open the first collapsible
    // this.openFirst();

    // toggle the button class
    this.categoryButtons.forEach(button => button.classList.toggle('button--primary', button.dataset.faqCategory === category));
    this.categoryButtons.forEach(button => button.classList.toggle('button--outline', button.dataset.faqCategory !== category));
  }

  openFirst() {
    const visibleQuestions = Array.from(this.questions).filter(question => !question.classList.contains('hidden'));
    visibleQuestions[0].classList.add('cc-is-open');
  }

  showNoResultsText(show = false) {
    if (show) {
      if (this.noResultsText && this.noResultsText.classList.contains('hidden')) this.noResultsText.classList.remove('hidden');
    }
    else {
      if (this.noResultsText && !this.noResultsText.classList.contains('hidden')) this.noResultsText.classList.add('hidden');
    }
  }

  search(event) {
    event.preventDefault();

    // hide the text again
    this.showNoResultsText(false);

    // Get the search terms from the input field
    var searchTerm = event.target.querySelector('input').value;

    // Tokenize the search terms and remove empty spaces
    var tokens = searchTerm
      .toLowerCase()
      .split(' ')
      .filter(function(token){
        return token.trim() !== '';
      });

    if (tokens.length) {
      //  Create a regular expression of all the search terms
      const searchTermRegex = new RegExp(tokens.join('|'), 'gim');
      const filteredList = this.json.filter((faq) => {
        // Create a string of all object values
        let faqString = '';

        for (const key in faq) {
          if (key !== 'index' && key !== 'category') {
            if (Object.hasOwnProperty.call(faq, key)) {
              const item = faq[key];
              faqString += item.toString().toLowerCase().trim() + ' ';
            }
          }
        }
        // Return book objects where a match with the search regex if found
        return faqString.match(searchTermRegex);
      });

      // show/hide all the relevant search results
      this.questions.forEach((question) => {
        if (question.classList.contains('cc-is-open')) question.classList.remove('cc-is-open');
        if (!question.classList.contains('hidden')) question.classList.add('hidden');
      });
      this.categoryButtons.forEach(button => (button.classList.contains('button--primary')) && button.classList.remove('button--primary'));

      // display the relevant questions
      if (filteredList.length > 0) {
        filteredList.forEach((result) => {
          this.querySelector(`[data-faq-index="${result.index}"]`).classList.remove('hidden');
        });

        // open the first collapsible
        this.openFirst();
      }
      else {
        this.showNoResultsText(true);
      }

      // Scroll to FAQ top
      window.scrollTo({ top: this.querySelector('[data-faq-questions-wrapper]').offsetTop - 84,
        behavior: 'smooth' });

      // reset the classes for the buttons
      this.categoryButtons.forEach(button => button.classList.add('button--outline'));
    }
  }
}
if (!customElements.get('faq-categories')) {
  customElements.define('faq-categories', FaqCategories);
}